import { Injectable } from '@angular/core';
import { Observable, Subject, fromEvent } from 'rxjs';
import { debounceTime, map, distinctUntilChanged, startWith } from 'rxjs/operators';
import { ScreenBreakpoint, determineScreenBreakpoint } from '../models/screen-width-breakpoints';

const MOBILE_WIDTH_THRESHOLD = 768;

@Injectable({
  providedIn: 'root',
})
export class ResizeService {
  isMobile: boolean; // LEGACY PROPERTY USED BY SEVERAL COMPONENTS AND SERVICES, BEWARE!
  private currentScreenBreakpoint: ScreenBreakpoint;
  private deviceChange = new Subject<ScreenBreakpoint>();

  constructor() {
    fromEvent(window, 'resize')
      .pipe(
        debounceTime(200),
        map(() => window.innerWidth),
        distinctUntilChanged(),
        startWith(window.innerWidth)
      )
      .subscribe((width) => this.determineDevice(width));
  }

  private determineDevice(width: number) {
    this.isMobile = width < MOBILE_WIDTH_THRESHOLD;
    this.currentScreenBreakpoint = determineScreenBreakpoint(width);
    this.deviceChange.next(this.currentScreenBreakpoint);
  }

  public getDeviceChangeObs() {
    return this.deviceChange.asObservable();
  }

  public getCurrentScreenBreakpoint() {
    return this.currentScreenBreakpoint;
  }
}
